import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { meetingClient } from '../client/meetingClient';


type Options = {
  retry: boolean
};

const defaultOptions: Partial<Options> = {
  retry: false,
};

export const useMeetings = (params: Meetings.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getMeetings, params],
    queryFn: () => meetingClient.getMeetings(params),
    retry: options.retry !== undefined ? options.retry : defaultOptions.retry,
  });

  return {
    ...rest,
    count: data?.count || 0,
    meetings: data?.results || [],
  };
};
